/* Auswahl behalten 12.10.2026 (Theme-Kopie PMP FUNKTION 1210).
   Wechselt der Kunde Format (Hoch-/Querformat), Form oder Kleidungsart, baut teeinblue die Optionen neu auf und setzt
   Größe, Rahmen, Farbe und Stil auf den Standard zurück. Dieses Skript merkt sich, was der Kunde selbst angeklickt hat,
   und setzt es nach dem Wechsel wieder, sofern es die Kombination gibt. Heißt ein Wert je Form anders
   ("Paw Shaped Rug 70x50 cm" gegen "70x50 cm / 20x28\""), zählen die Maße. Gibt es nichts Passendes, bleibt der Standard stehen. */
(() => {
  'use strict';
  if (window.__pmpAuswahl) return;
  window.__pmpAuswahl = true;
  const FORM = '.tee-form-wrapper';
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
  const kern = (v) => { const m = String(v).match(/\d+\s*x\s*\d+/i); return m ? m[0].replace(/\s+/g, '').toLowerCase() : norm(v); };
  const merk = { radio: {}, select: {} };
  let frist = 0, sperre = false;

  const gruppen = () => [...document.querySelectorAll(FORM + ' .tee-option')].filter((o) =>
    !o.classList.contains('tee-available-products') && o.querySelector('input[type=radio]') &&
    !o.querySelector('.tee-option')); // innerste Gruppe
  const titel = (o) => norm(o.querySelector('.tee-option__title') && o.querySelector('.tee-option__title').textContent);
  const nichtDa = (i) => { const r = i.closest('.tee-radio'); return !!(r && (r.classList.contains('tee-radio--unavailable') || r.classList.contains('tee-radio--disabled'))); };
  const feldName = (f) => norm(f.querySelector('.tee-field__heading') && f.querySelector('.tee-field__heading').textContent).replace(/\*$/, '');

  // Merken: nur echte Klicks des Kunden (isTrusted), nie unsere eigenen
  document.addEventListener('click', (e) => {
    if (!e.isTrusted || sperre) return;
    const t = e.target;
    if (!t || !t.closest || !t.closest(FORM)) return;
    const g = t.closest('.tee-option');
    if (!g) return;
    frist = Date.now() + 12000;
    if (g.classList.contains('tee-available-products')) return;
    const name = titel(g);
    const lab = t.closest('label');
    const inp = t.matches && t.matches('input[type=radio]') ? t : (lab && lab.control) || (lab && lab.htmlFor && document.getElementById(lab.htmlFor));
    if (name && inp && inp.type === 'radio') merk.radio[name] = inp.value;
  }, true);
  document.addEventListener('change', (e) => {
    if (!e.isTrusted || sperre) return;
    const s = e.target;
    if (!s || s.tagName !== 'SELECT' || !s.closest(FORM)) return;
    const f = s.closest('.tee-field');
    const o = s.options[s.selectedIndex];
    if (f && o && !o.disabled) merk.select[feldName(f)] = norm(o.textContent);
  }, true);

  const stelleWiederHer = () => {
    if (Date.now() > frist) return;
    let getan = false;
    sperre = true;
    try {
      for (const g of gruppen()) {
        const soll = merk.radio[titel(g)];
        if (!soll) continue;
        // F061 (31.10.2026): Bei Kleidung (Kleidungsstück mit Farbe und Größe) entscheidet allein die Kleidungslogik in newsletter.js
        // (window.__pmpKombi) über Farbe und Größe. Zwei Skripte mit verschiedenen Regeln klickten sonst abwechselnd
        // (Olivgrün gegen Schwarz 5XL), bis teeinblue eine ungültige Kombination erwischte und Preis und Auswahl leerte.
        if (window.__pmpKombi && window.__pmpKombi.zustaendig(g)) continue;
        // F061 (30.10.2026): teeinblue sperrt nicht verfügbare Kombinationen nicht per disabled, sondern nur per Klasse
        // tee-radio--unavailable. Ein Klick darauf (z. B. Sweatshirt Olivgrün 5XL) leert Preis und Auswahl. Solche Werte nie setzen,
        // dann bleibt die von teeinblue gewählte verfügbare Ersatzkombination stehen.
        const radios = [...g.querySelectorAll('input[type=radio]')].filter((i) => !i.disabled && !nichtDa(i));
        const genau = radios.find((i) => i.value === soll);
        let ziel = genau || radios.find((i) => kern(i.value) === kern(soll));
        if (!ziel && g.classList.contains('tee-option--size')) {
          // Größe gibt es in der neuen Farbe oder dem neuen Kleidungsstück nicht: die nächstliegende verfügbare Größe nehmen
          const alle = [...g.querySelectorAll('input[type=radio]')];
          const pos = alle.findIndex((i) => i.value === soll);
          if (pos > -1) {
            let best = null, abst = 1e9;
            radios.forEach((i) => { const d = Math.abs(alle.indexOf(i) - pos); if (d < abst || (d === abst && alle.indexOf(i) > pos)) { abst = d; best = i; } });
            ziel = best;
          }
        }
        if (!ziel || ziel.checked) continue;
        const lab = ziel.id && g.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(ziel.id) : ziel.id) + '"]');
        (lab || ziel).click();
        getan = true;
        break; // ein Schritt je Durchlauf, teeinblue baut danach neu auf
      }
      if (!getan) {
        document.querySelectorAll(FORM + ' .tee-field select, .tee-customize-main-form select').forEach((s) => {
          if (getan) return;
          const f = s.closest('.tee-field');
          const soll = f && merk.select[feldName(f)];
          if (!soll) return;
          const cur = s.options[s.selectedIndex];
          if (cur && norm(cur.textContent) === soll) return;
          const o = [...s.options].find((x) => !x.disabled && norm(x.textContent) === soll);
          if (!o) return;
          s.value = o.value;
          s.dispatchEvent(new Event('input', { bubbles: true }));
          s.dispatchEvent(new Event('change', { bubbles: true }));
          getan = true;
        });
      }
    } finally { setTimeout(() => { sperre = false; }, 30); }
  };

  let geplant = false;
  const plane = () => { if (geplant || Date.now() > frist) return; geplant = true; setTimeout(() => { geplant = false; stelleWiederHer(); }, 250); };
  new MutationObserver(plane).observe(document.body, { childList: true, subtree: true });
  setInterval(plane, 500);
})();
